import { render, staticRenderFns } from "./RiskUser.vue?vue&type=template&id=261705a3&scoped=true"
import script from "./RiskUser.vue?vue&type=script&lang=js"
export * from "./RiskUser.vue?vue&type=script&lang=js"
import style0 from "./RiskUser.vue?vue&type=style&index=0&id=261705a3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261705a3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('261705a3')) {
      api.createRecord('261705a3', component.options)
    } else {
      api.reload('261705a3', component.options)
    }
    module.hot.accept("./RiskUser.vue?vue&type=template&id=261705a3&scoped=true", function () {
      api.rerender('261705a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/membershipList/components/RiskUser.vue"
export default component.exports